import { StdLookupAttribute } from './std-lookup-attribute.model';

export class DateAttributes {
    id: number;
    stdLookupAttribute: StdLookupAttribute;
    previousDateAllowed: number | string;
    futureDateAllowed: number | string;
}
